import ButtonStyle from "./Button.module.scss"

interface ButtonProps {
  text?: string
  specialClass: string
  handleClick: () => void
  icon?: React.JSX.Element
  isUnlock?: boolean
  padding?: string | number[]
  isBackgroundTransparent?: boolean
}

const Button = ({
  text,
  specialClass,
  handleClick,
  icon,
  isBackgroundTransparent = false,
  isUnlock,
  padding,
}: ButtonProps): React.JSX.Element => {
  let paddingValue: string | undefined

  if (Array.isArray(padding)) {
    paddingValue = padding.map(p => (typeof p === "number" ? `${p}px` : p)).join(" ")
  } else if (typeof padding === "string") {
    paddingValue = padding
  }

  return (
    <button
      onClick={handleClick}
      className={`
        ${ButtonStyle.buttonContainer}
        ${specialClass}
        ${isUnlock !== undefined && !isUnlock ? ButtonStyle.active : ""}
        ${isUnlock !== undefined && isUnlock ? ButtonStyle.notActive : ""}
      `}
      style={{ padding: paddingValue, backgroundColor: isBackgroundTransparent ? "transparent" : "" }}
    >
      {icon ? (
        icon
      ) : (
        <>
          <span className={ButtonStyle.dot}></span>
          <span>{text}</span>
        </>
      )}
    </button>
  )
}

export default Button
